import React, { useCallback, useEffect, useRef, useState } from "react";
import { Box, Page, Tabs, Toast } from "@shopify/polaris";
import CommonFilterBox from "./component/CommonFilterBox";
import CommonWinningFilterBox from "./component/CommonWinningFilterBox";
import SourcingRequestBox from "./SourcingRequest/SourcingRequestBox";
import ImportProductBox from "./ImportProduct/Index";
import FirstTimeTips from "./component/FirstTimeTips";
import { useHistory, withRouter } from "react-router-dom/cjs/react-router-dom";
import PersonalAgentModal from "../SubscriptionPaid/components/PersonalAgentModal";
import intl from "../../../i18n/intl"
import { reqGetNewSubscribeLimit, reqGetNewSubscribeList, reqGetUserPoints,  reqGoogleAnalytics, reqPostNewSubscribeChange,  } from "../../../api";
import SourcingRequestModal from "./SourcingRequest/component/SourcingRequestModal";
import NoviceSourcingModal from "../../../components/NoviceGuidance/NoviceSourcingModal";
import { store } from "../../../store";
import { changeSourcingData } from "../../../slice";
import EnoughQuotaModal from "./SourcingRequest/component/EnoughQuotaModal";
import EnoughPointsModal from "./SourcingRequest/component/EnoughPointsModal";
import { useSelector } from "react-redux";
import utils from "../../../utils/utils";
import defalutData from "../SubscriptionPaid/components/subData";
const ProductSelectionClass = ({handleModalCallback}) => {
  const tabs = [
    {
      id: "all-customers-1",
      content: "Marketplace",
      accessibilityLabel: "Marketplace",
      panelID: "all-customers-content-1",
    },
    {
      id: "accepts-marketing-1",
      content: "Winning Product",
      panelID: "accepts-marketing-content-1",
    },
    {
      id: "repeat-customers-1",
      content: "Sourcing Request",
      panelID: "repeat-customers-content-1",
    },
    {
      id: "prospects-1",
      content: "Product Importer",
      panelID: "prospects-content-1",
    },
  ];
  const shopify = window.shopify;
  const targetRef = useRef(null); // 用于获取目标元素的引用
  const [showPopup, setShowPopup] = useState(false); // 控制弹出框显示
  const [typeTarget, setTypeTarget] = useState("collect");
  const [popupStyle, setPopupStyle] = useState({}); // 动态弹出框样式
  const handleTogglePopup = (val) => {
    const targetElement = targetRef.current;

    if (targetElement && !val) {
      const rect = targetElement.getBoundingClientRect();
      setTypeTarget('collect')
      // 计算弹出框的位置
      const style = {
        left: rect.left + window.scrollX + "px", // 加上滚动偏移
        top: rect.bottom + window.scrollY + "px", // 在目标元素下方
      };

      setPopupStyle(style); // 设置弹出框位置
      setShowPopup((prev) => !prev); // 显示或隐藏弹出框
    }else {
      let  style = {
        left: 250 + "px", // 加上滚动偏移
        top: 130 + "px", // 在目标元素下方
      };
      if (shopify) {
        style = {
          left: 10 + "px", // 加上滚动偏移
          top: 390 + "px", // 在目标元素下方
        };
      }
      setTypeTarget("add_product")
      setPopupStyle(style); // 设置弹出框位置
      setShowPopup((prev) => !prev); // 显示或隐藏弹出框
    }
  };

  useEffect(()=>{
    let isMount = false;
    if (!isMount && showPopup) {
      setTimeout(() => {
        setShowPopup(false)
      }, 4000);
    }
    return () => {
      isMount = true;
    };
  },[showPopup])
  const handleTabChange = (val) => {
    // 切换tab
    setSelected(val);
    setShowPopup(false);
    if (shopify) {
      if (Number(val) === 0) {
        // utils.routeListen(`/admin/product_selection?select_tab=0`);
        utils.routeJump1(router,`/admin/product_selection?select_tab=0`)
      }else {
        // utils.routeListen(`/admin/product_selection?select_tab=${val}`);
        utils.routeJump1(router,`/admin/product_selection?select_tab=${val}`)
      }
    }else {
      window.history.pushState(null, "", `?select_tab=${val}`);
    }
    
  };
  const router = useHistory();

  const getDefaultSelected = () => {
    const { search } = router.location;
    const urlParams = new URLSearchParams(search);
    const selectTab = Number(urlParams.get("select_tab"));
    const num = !isNaN(selectTab) && selectTab > 0 && selectTab <= 3 ? selectTab : 0;
    // 验证 select_tab 是否有效
    return num;
  };

  const [selected, setSelected] = useState(getDefaultSelected);
  // 初始化时运行副作用
  useEffect(() => {
    let isMount = false;
    const { search } = router.location;
    let url = new URLSearchParams(search);
    let select_tab = url.get("select_tab");
    if (!isMount) {
      if (select_tab && !isNaN(Number(select_tab))) {
        // 获取select_tab参数 重新设置tab
        if (Number(select_tab) <= 0 || Number(select_tab) > 3) {
          setSelected(0);
          window.history.replaceState(null, "", window.location.pathname);
        } else {
          setSelected(Number(select_tab));
          window.history.pushState(null, "", `?select_tab=${select_tab}`);
        }
      } else {
        if (select_tab && (Number(select_tab) <= 0 || Number(select_tab) > 3)) {
          setSelected(0);
          window.history.replaceState(null, "", window.location.pathname);
        }
      }
    
      getSubscribeList(); // 获取订阅列表
      getUserPoints(); // 获取用户积分
      getUserPlan(); // 获取套餐权益次数
    }
    return () => {
      isMount = true;
    };
   
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  
  const [planShow, setPlanShow] = useState(true);
  const [subList, setSubList] = useState(defalutData.subList); // 套餐列表
    // 会员限制
    const [planData,setPlanData] = useState({
        sourcingLimit: 0, // 当前sourcing次数
        sourcingDay: 3, // sourcing限制次数
        productLimit:0,// 当前产品次数
        productDay: 10,// 日产品次数
        aliexpressLimit: 0,// 当前速卖通导入次数
        aliexpressDay: 10,// 速卖通x限制导入次数
      })
      // 积分剩余
      const [userPoints,setUserPoints] = useState({
        userPointsData:{
          available_points:0,
          total_points:0
        },
        userPointsRedeem:{
          open:false,
          id:0,
          isDetail:false,
          is_new:0,
          isPoints:false
        },
      })
  
  // 获取积分
  const getUserPoints = async () => {
    try {
      let res = await reqGetUserPoints();
      if (res.code === "200") {
        setUserPoints((prevValue) => ({
          ...prevValue,
          userPointsData: res.data,
        }));
      }
    } catch (error) {}
  };

//   获取套餐功能次数
  const getUserPlan = async ()=>{
    let response = await reqGetNewSubscribeLimit()
   
        if (response.code === "200") {
          let resList = response?.data.limit;
          let resTotal = response?.data?.total;
          setPlanData((prevValue)=>({
            ...prevValue,
            sourcingLimit:resList.sourcing + resList.sourcing_job,
            use_sourcing:resList.use_sourcing,//sourcing加量包使用
            add_sourcing:resTotal?.add_sourcing,
            sourcingDay: resTotal?.sourcing_num,
            use_product:resList.use_product,
            add_product:resTotal.add_product,
            productLimit: resList.dsm,
            productDay: resTotal.dsm_product_num,
            aliexpressLimit:resList.aliexpress + resList.aliexpress_job,
            aliexpressDay:resTotal.ali_product_num,
          }))
        }
  }
  // 高级套餐
  const [premiumData, setPremiumData] = useState({
    open: false,
    agent_list: [],
  });
  const handlePremiumOff = () => {
    setPremiumData((prevValue) => ({
      ...prevValue,
      open: false,
    }));
  };
   const enhancePackageList = (
     list,
     currentPlanId,
     pricingData,
     trialDays,
     agentList,
     firstPurchase,
     isZt,
     glassesLevel
   ) => list.map(item => {
     const priceInfo = pricingData.find(p => p.key === item.id) || {};
     const isCurrentPlan = item.id === currentPlanId;
     const isAnnualPlan = priceInfo?.is_yearly === 1;
     let button = "";
     let disabled = false;
     if (glassesLevel === 1) {// 当前为年套餐页
       if (isAnnualPlan) {
         if (isCurrentPlan) {// 当前为年套餐页、未购买年套餐的
           if (currentPlanId === 0) {
             // 未付费用户
             button = "Current Plan";
             disabled = true;
           } else if (item.id === 0) {
             button = "Downgrade";
           } else {
             button = "Current Plan";
             disabled = true;
           }
         } else if (
           (item.id === 0 && item.id !== currentPlanId) ||
           (item.id === 4 && currentPlanId !== 0 && !isCurrentPlan)
         ) {
           button = "Downgrade";
         } else if (currentPlanId !== 4 && item.id < currentPlanId) {
           button = "Downgrade";
         } else if (trialDays !== 0 && item.id !== 4) {
           button =  `Start ${trialDays}-day free trial`;
         } else {
           button = "Select Plan";
         }
       } else {
         if (isCurrentPlan) {
           if (currentPlanId === 0) {
             // 未付费用户
             button = "Current Plan";
             disabled = true;
           }else if (item.id === 4 && currentPlanId === 0) {
             button = "Select Plan";
           } else {
             button = "Downgrade";
           }
         } else if (
           (item.id === 0 && item.id !== currentPlanId) ||
           (item.id === 4 && currentPlanId !== 0 && !isCurrentPlan)
         ) {
           if (item.id === 4 && currentPlanId === 0) {
             button = "Select Plan";
           }else {
             button = "Downgrade";
           }
         } else if (currentPlanId !== 4 && item.id < currentPlanId) {
           button = "Downgrade";
         } else if (trialDays !== 0 && item.id !== 4) {
           button = `Start ${trialDays}-day free trial`;
         } else {
           if (item.id === 4 && currentPlanId === 0) {
             button = "Select Plan";
           }else {
             button = "Downgrade";
           }
         }
         
       }
     }else {
       if (isAnnualPlan) {
         if (isCurrentPlan) {// 当前为年套餐页、未购买年套餐的
           if (currentPlanId === 0) {
             // 未付费用户
             button = "Current Plan";
             disabled = true;
           } else if (item.id === 0) {
             button = "Downgrade";
           }else if (trialDays !== 0  && item.id !== 4) {
             button =  `Start ${trialDays}-day free trial`;
           } else {
             button = "Select Plan";
           }
         } else if (
           (item.id === 0 && item.id !== currentPlanId)
         ) {
           button = "Downgrade";
         } else if (trialDays !== 0 && item.id !== 4) {
           button =  `Start ${trialDays}-day free trial`;
         } else {
           button = "Select Plan";
         }
       } else {
         if (isCurrentPlan) {
           if (currentPlanId === 0) {
             // 未付费用户
             button = "Current Plan";
             disabled = true;
           } else if (item.id === 0) {
             button = "Downgrade";
           } else {
             button = "Current Plan";
             disabled = true;
           }
         } else if (
           (item.id === 0 && item.id !== currentPlanId) ||
           (item.id === 4 && currentPlanId !== 0 && !isCurrentPlan)
         ) {
           button = "Downgrade";
         } else if (currentPlanId !== 4 && item.id < currentPlanId) {
           button = "Downgrade";
         } else if (trialDays !== 0  && item.id !== 4) {
           button = `Start ${trialDays}-day free trial`;
         } else {
           button = "Select Plan";
         }
         
       }
       
     }
   
     return {
       ...item,
       ...priceInfo,
       first_purchase: firstPurchase,
       is_zt: isZt,
       bill_level: currentPlanId,
       agent: item.id === 5 ? agentList : [],
       button,
       disabled,
       loading:false
     };
   });
 // 获取套餐数据
   const getSubscribeList = async () => {
     try {
       let res = await reqGetNewSubscribeList();
       if (res.code === "200") {
         const {
          level,
           trial_days,
           agent_list,
           first_purchase,
           is_zt,
           glasses_level,
         } = res.data;
         setPremiumData((prevValue) => ({
           ...prevValue,
           agent_list: res.data.agent_list,
         }));
         setPlanShow((glasses_level === 1 ) ? false : true)
         // 处理月套餐
         const enhancedMonth = enhancePackageList(
           subList.month,
           level,
           res.data.package.month,
           trial_days,
           agent_list,
           first_purchase,
           is_zt,
           glasses_level
         );
         // 处理年套餐
         const enhancedYear = enhancePackageList(
           subList.year,
           level,
           res.data.package.year,
           trial_days,
           agent_list,
           first_purchase,
           is_zt,
           glasses_level
         );
 
         setSubList((prev) => ({
           ...prev,
           month: enhancedMonth,
           year: enhancedYear,
         }));
       }
     } catch (error) {}
   };
   // 升降级
   const handleMageUpgrade = async ( 
     id,
     val = '',
     email = "",
     social = "",
     am_id = "",
   )=>{
     try {
       let param = {
         package_id: id,
         email: email,
         social: social,
         am_id: am_id,
         is_yearly:!planShow ? 1 : 0,
       };
       if (val && val !== "") {
         param.remark = val;
       }
     
     let res = await reqPostNewSubscribeChange(param);
     if (res.code === "200") {
      if (res?.data?.id !== "") {
        if (id !== 0) {
          window.top.location.href = res.data.url;
          toastFun(res.msg);
        }
      }
    } else {
      toastFun(intl.get("Something wrong"));
    }
   } catch (error) {
       
   }
   }

  const plan_level = useSelector(
    (state) => state.languageReducer.subScriptData
  );
// 次数不足
const [sourcingLimitModal,setSourcingLimitModal] = useState(false)

// 达到上限
const [enoughPoint,setEnoughPoint] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [noviceModal,setNoviceModal] = useState(false);
  const openPopup = () => {
    setIsPopupOpen(true);
  };

  const closePopup = () => {// 关闭弹窗
    setIsPopupOpen(false);
  };
  const [productTitle,setProductTitle] = useState('')
   // 打开sourcing弹窗，详情弹窗
   const handleSourcingModal = () => {
    //Sourcing页面sourcing按钮点击gtag
    reqGoogleAnalytics('click', 'sourcing_sourcing_click');
    // 查看sourcing详情
    
    try {
    
    if (planData.use_sourcing >= planData.add_sourcing && planData.sourcingLimit >= planData.sourcingDay) {
      if ((plan_level.bill_level === 5 || plan_level.level === 5) && userPoints.userPointsData.available_points < 200) {
          setEnoughPoint(true)
          return
      }else {
        setSourcingLimitModal(true)
      }
      
    }else {
      if (shopify) {
        window.history.replaceState({}, '', '/admin/product_selection/sourcing-detail')
        handleModalCallback('/admin/product_selection/sourcing-detail','Sourcing_Detail_Modal',{isPoints:false,productTitle})
        store.dispatch(changeSourcingData({sourcing:{
          show:true,
        }}));
      }else {
        openPopup()
      }
    }
  } catch (error) {
      
  }
  }
 
  const handleSubmit = (val) => {
    if (val) {
        if (val === 5) {
            setPremiumData((prevValue) => ({
                ...prevValue,
                open: true,
              }));
            setSourcingLimitModal(false)
        }
        if (val === 6) {
          setUserPoints((prevValue)=>({
            ...prevValue,
            userPointsRedeem:{
              ...prevValue.userPointsRedeem,
              isPoints:true
            }
          }))
          setSourcingLimitModal(false)
          if (shopify) {
            handleModalCallback('/admin/product_selection/sourcing-detail','Sourcing_Detail_Modal',{isPoints:true})
            store.dispatch(changeSourcingData({sourcing:{
              show:true,
            }}));
            
          }else {
            openPopup()
          }
        }
        if (val <5) {
          handleMageUpgrade(val)
        }
    }
  };
  const [toast, setToast] = useState(false);
  const [toastError, setToastError] = useState(false);
  const [toastMsg, setToastMsg] = useState("");

  const toggleToast = useCallback(() => setToast((toast) => !toast), []);

  const toastMarkup = toast ? (
    <Toast content={toastMsg} onDismiss={toggleToast} error={toastError} />
  ) : null;

  const toastFun = (msg, error) => {
    setToastError(error);
    setToastMsg(msg);
    setToast(false);
    toggleToast();
  };
  
  const pageContent = (
    <div className="product_management_container">
      <Page fullWidth={true}>
        <Box className="product_selection_container_tab">
        <Tabs tabs={tabs} selected={selected} onSelect={handleTabChange}></Tabs>
        </Box>
        {selected === 0 && (
          <CommonFilterBox
            handleTogglePopup={handleTogglePopup}
            targetRef={targetRef}
            planData={planData}
            setPlanData={setPlanData}
            userPoints={userPoints}
            setUserPoints={setUserPoints}
            premiumData={premiumData}
            setPremiumData={setPremiumData}
            handlePremiumOff={handlePremiumOff}
            handleMageUpgrade={handleMageUpgrade}
            subList={subList}
            toastFun={toastFun}
            handleSourcingModal={handleSourcingModal}
            setNoviceModal={setNoviceModal}
            setProductTitle={setProductTitle}
            planShow={planShow}
          />
        )}
        {selected === 1 && (
          <CommonWinningFilterBox
          handleTogglePopup={handleTogglePopup}
          targetRef={targetRef}
          planData={planData}
          setPlanData={setPlanData}
          userPoints={userPoints}
          setUserPoints={setUserPoints}
          premiumData={premiumData}
          setPremiumData={setPremiumData}
          handlePremiumOff={handlePremiumOff}
          handleMageUpgrade={handleMageUpgrade}
          subList={subList}
          toastFun={toastFun}
          handleSourcingModal={handleSourcingModal}
          setNoviceModal={setNoviceModal}
          setProductTitle={setProductTitle}
          planShow={planShow}
          />
        )}
        {selected === 2 && <SourcingRequestBox 
        planData={planData}
        setPlanData={setPlanData}
        userPoints={userPoints}
        setUserPoints={setUserPoints}
        premiumData={premiumData}
        setPremiumData={setPremiumData}
        handlePremiumOff={handlePremiumOff}
        handleMageUpgrade={handleMageUpgrade}
        planShow={planShow}
        subList={subList}
        handleModalCallback={handleModalCallback}
        toastFun={toastFun} />}
        {selected === 3 && <ImportProductBox  
        planData={planData}
        subList={subList}
        userPoints={userPoints} 
        setPlanData={setPlanData}
        setUserPoints={setUserPoints}
        premiumData={premiumData}
        setPremiumData={setPremiumData}
        handlePremiumOff={handlePremiumOff}
        handleMageUpgrade={handleMageUpgrade}
        planShow={planShow}
        />}

        {/* 创建source */}
      {isPopupOpen && <SourcingRequestModal
          isOpen={isPopupOpen}
          onClose={closePopup}
          show={true}
          title={productTitle}
          updateCallBackFun={() => {
            setProductTitle("")
            setPlanData((prevValue) => {
              const { use_sourcing, add_sourcing, sourcingLimit } = prevValue;
              const usageToAdd = 1;
              const remainingQuota = add_sourcing - use_sourcing;
            
              let updatedUseSourcing = use_sourcing;
              let updatedSourcingLimit = sourcingLimit;
            
              if (add_sourcing > 0 && use_sourcing >= add_sourcing) {
                // 加量包已消耗完，全部计入sourcingLimit
                updatedSourcingLimit += usageToAdd;
              } else if (remainingQuota >= usageToAdd) {
                // 加量包足够使用
                updatedUseSourcing += usageToAdd;
              }
            
              return {
                ...prevValue,
                use_sourcing: updatedUseSourcing,
                sourcingLimit: updatedSourcingLimit,
              };
            });
            if (userPoints.userPointsRedeem.isPoints) {
              setUserPoints((prevValue)=>({
                ...prevValue,
                userPointsData:{
                  ...prevValue.userPointsData,
                  available_points:Number(prevValue.userPointsData.available_points) - 200
                }
              }))
              toastFun("Successfully Redeemed")
            }
          }}
          requestCreateCallBack={() => {}}
          handlePointsRedeemLess={() => {}}
          id={0}
          isPoints={userPoints.userPointsRedeem.isPoints}
          type={1}
          is_new={true}
          isDetail={false}
        />}
         {/* 次数不够 */}
        {sourcingLimitModal && <EnoughQuotaModal type={'sourcing'} handleSubmit={handleSubmit} planShow={planShow}  sourcingLimitModal={sourcingLimitModal} userPoints={userPoints} subList={subList} setSourcingLimitModal={setSourcingLimitModal}/>}
        {/* 会员上限且积分不够 */}
        {enoughPoint && <EnoughPointsModal type={'sourcing'} open={enoughPoint} setOpen={setEnoughPoint}/>}
        {/* 引导视频 */}
        {noviceModal && <NoviceSourcingModal upgradeOpen={noviceModal} setUpgradeOpen={()=>setNoviceModal(false)}/>}
        {/* agent选择 */}
        {premiumData.open && <PersonalAgentModal
          premiumData={premiumData}
          handlePremiumOff={handlePremiumOff}
          handleMageUpgrade={handleMageUpgrade}
        />}
        {/* 弹出框 */}
        {showPopup && (
          <FirstTimeTips typeTarget={typeTarget} popupStyle={popupStyle} setShowPopup={setShowPopup} />
        )}
      </Page>
    </div>
  );
  return (
    <div className="product_selection_container">
      {pageContent}
      {toastMarkup}
    </div>
  );
};




export default withRouter(ProductSelectionClass);
